import request from '@/utils/changanRequest'
// 新增居民求助信息
export function addAssistance(data) {
  return request({
    url: '/system/assistance',
    method: 'post',
    data: data
  })
}

// 查询居民求助信息详细
export function getAssistance(query) {
  return request({
    url: '/system/assistance/wechat/details',
    method: 'get',
    params: query
  })
}
// 查询居民求助类型列表
export function listType(query) {
  return request({
    url: '/system/assistanceType/wechat/list',
    method: 'get',
    params: query
  })
}
